import PropTypes from "prop-types"
import { StackView } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"

const MissingAttendeeInfoError = ({
  className,
  errorString = "Not answered",
  showIcon = true,
  icon = "general#exclamation-triangle",
  showErrorExplanation = true,
  ...props
}) => (
  <>
    {showErrorExplanation ? (
      <StackView
        axis="horizontal"
        alignment="center"
        className={`c-warning font-size-4 ${className ? className : ""}`}
        spacing={0.5}
        {...props}
      >
        {showIcon && <Icon symbol={icon} className="c-warning-icon" />}
        <span css={{ fontWeight: 500 }}>{errorString}</span>
      </StackView>
    ) : (
      "—"
    )}
  </>
)

MissingAttendeeInfoError.propTypes = {
  errorString: PropTypes.string,
  showIcon: PropTypes.bool,
  showErrorExplanation: PropTypes.bool,
  icon: PropTypes.string,
  className: PropTypes.string
}

export default MissingAttendeeInfoError
